export interface ListError {
  key?: string
  value?: string
}
export interface ListWarning {
  key?: string
  value?: string
}
export interface SessionData {
  isCSR?: boolean
  isCSRSupervisor?: boolean
  wellType: number
  plateName: string
  researcher: string
  channelType: number
  plateType: string
  countryCode: string
  totalBaseCount: number
  plateId: number
  countOfWells: number
  material?: string
  isAmountSelected?: boolean
  isConcentrationSelected?: boolean
  purification: string
  format: string
  concentration: string
  amount: string
  scale: string
  daughterPlateCount?: string
  isOverridden: boolean
  isSpecificationsOverridden?: boolean
  isShippingOverridden?: boolean
  isPackageTypeOther?: boolean
  plateCopiesRange?: string
  pageNo: number
  applyToAll: boolean
  researcherNameError: string[]
  plateNameError: string[]
  category: string
  packageType: string
  shipping: string
  stockPlate: string
  selectedPackageType: string
  isConcentrationOther: boolean
  productType: string
  __typename?: string
  wellList: WellList[]
  biTubeWellList: []
}
export interface WellList {
  id: number
  wellType: number
  mixed?: number | null
  oligoId: number
  name: string
  sequence: string
  baseCount: number
  threeMod: string
  fiveMod: string
  format: string
  other: string
  purification: string
  concentration: string
  scale: string
  countryCode: string
  productType: string
  technicalSequence: string
  amount: string
  tubes: number
  terms: boolean
  flag: number
  row: string
  column: string
  comments: string
  additionalComments: string
  isOverridden: boolean
  orderItemId: string
  pageNo: number
  packageType: string
  shipping: string
  excessMaterial: boolean
  molecularWeight?: string
  primerDimer: string
  secondaryStructure: string
  gcContent: string
  meltingTemparature: string
  epsilon: number
  additionalServices: string[]
  listError: ListError[]
  listWarning: ListWarning[]
  listAdditionalServices: string[]
  listNgso: string[]
  listISO: string[]
  crossContamination: string
  qualitySystem: string
  category: string
  ngsoType: string
  price: string
  priceHeaderError: string
  currency: string
  currencySymbol: string
  analyticalHPLC: string
  certificateOfAnalysis: string
  __typename?: string
}

export interface ProductInformationResponse {
  productType?: string | null | undefined
  typeCode?: string | null | undefined
  packageType?: string | null | undefined
  instructions?: string | null | undefined
  brand?: string | null | undefined
  shippingOptions?: any[] | null | undefined
  companionProducts?: any[] | null | undefined
  currencyFormat?: string
  decimalSeparator?: string
  thousandSeparator?: string
  prefixCurrecny?: boolean
  thousandSpacing?: string
}

export interface NGSOState {
  sessionData: SessionData[]
  productInformation: ProductInformationResponse
  isPageLoad: boolean
  stepNo: number
  uploadType: string
  errorFromConfirmOrderPage: string
}
export const emptyWellList = {
  __typename: '',
  additionalComments: '',
  additionalServices: [],
  amount: '',
  analyticalHPLC: '',
  baseCount: 0,
  category: '',
  certificateOfAnalysis: '',
  column: '',
  comments: '',
  concentration: '',
  countryCode: '',
  crossContamination: '',
  currency: '',
  currencySymbol: '',
  epsilon: 0,
  excessMaterial: false,
  fiveMod: '',
  flag: 0,
  format: '',
  gcContent: '',
  id: 0,
  isOverridden: false,
  listAdditionalServices: [],
  listError: [],
  listISO: [],
  listNgso: [],
  listWarning: [],
  meltingTemparature: '',
  molecularWeight: '',
  name: '',
  ngsoType: '',
  oligoId: 0,
  orderItemId: ' ',
  other: '',
  packageType: '',
  pageNo: 0,
  price: '',
  priceHeaderError: '',
  primerDimer: '',
  productType: '',
  purification: '',
  qualitySystem: '',
  row: '',
  scale: '',
  secondaryStructure: '',
  sequence: '',
  shipping: '',
  technicalSequence: '',
  terms: false,
  threeMod: '',
  tubes: 1,
  wellType: 0,
}
export const EmptyState = {
  __typename: '',
  amount: '',
  applyToAll: false,
  biTubeWellList: [],
  category: '',
  channelType: 0,
  concentration: '',
  countOfWells: 0,
  countryCode: '',
  daughterPlateCount: '',
  format: '',
  isAmountSelected: false,
  isCSR: false,
  isCSRSupervisor: false,
  isConcentrationOther: false,
  isConcentrationSelected: false,
  isOverridden: false,
  isPackageTypeOther: false,
  isShippingOverridden: false,
  isSpecificationsOverridden: false,
  material: '',
  packageType: '',
  pageNo: 0,
  plateCopiesRange: '',
  plateId: 1,
  plateName: '',
  plateNameError: [],
  plateType: '',
  productType: '',
  purification: '',
  researcher: '',
  researcherNameError: [],
  scale: '',
  selectedPackageType: '',
  shipping: '',
  stockPlate: '',
  totalBaseCount: 0,
  wellList: [emptyWellList],
  wellType: 0,
}
export const initialState: NGSOState = {
  errorFromConfirmOrderPage: '',
  isPageLoad: false,
  productInformation: {
    productType: '',
    typeCode: '',
    packageType: '',
    instructions: '',
    brand: '',
    shippingOptions: [''],
    companionProducts: [''],
    currencyFormat: '',
    decimalSeparator: '',
    thousandSeparator: '',
    prefixCurrecny: true,
    thousandSpacing: '',
  },
  sessionData: [
    {
      isCSR: false,
      isCSRSupervisor: false,
      wellType: 0,
      plateName: '',
      researcher: '',
      channelType: 0,
      plateType: '',
      countryCode: '',
      totalBaseCount: 0,
      plateId: 1,
      countOfWells: 0,
      material: '',
      isAmountSelected: false,
      isConcentrationSelected: false,
      purification: '',
      format: '',
      concentration: '',
      amount: '',
      scale: '',
      daughterPlateCount: '',
      isOverridden: false,
      isSpecificationsOverridden: false,
      isShippingOverridden: false,
      isPackageTypeOther: false,
      plateCopiesRange: '',
      pageNo: 0,
      applyToAll: false,
      researcherNameError: [],
      plateNameError: [],
      category: '',
      packageType: '',
      shipping: '',
      stockPlate: '',
      selectedPackageType: '',
      isConcentrationOther: false,
      productType: 'ngsotubes',
      __typename: '',
      wellList: [
        {
          __typename: '',
          additionalComments: '',
          additionalServices: [],
          amount: '',
          analyticalHPLC: '',
          baseCount: 0,
          category: '',
          certificateOfAnalysis: '',
          column: '',
          comments: '',
          concentration: '',
          countryCode: '',
          crossContamination: '',
          currency: '',
          currencySymbol: '',
          epsilon: 0,
          excessMaterial: false,
          fiveMod: '',
          flag: 0,
          format: '',
          gcContent: '',
          id: 0,
          isOverridden: false,
          listAdditionalServices: [],
          listError: [],
          listISO: [],
          listNgso: [],
          listWarning: [],
          meltingTemparature: '',
          molecularWeight: '',
          name: '',
          ngsoType: '',
          oligoId: 0,
          orderItemId: '',
          other: '',
          packageType: '',
          pageNo: 0,
          price: '',
          priceHeaderError: '',
          primerDimer: '',
          productType: ' ',
          purification: '',
          qualitySystem: '',
          row: '',
          scale: ' ',
          secondaryStructure: '',
          sequence: '',
          shipping: '',
          technicalSequence: '',
          terms: false,
          threeMod: '',
          tubes: 1,
          wellType: 0,
        },
      ],
      biTubeWellList: [],
    },
  ],
  stepNo: 0,
  uploadType: 'fileUpload',
}

type Action =
  | { type: 'INIT' }
  | { type: 'UPDATE_NGSO_INPUT'; data: SessionData[] }
  | { type: 'SET_PRODUCT_INFORMATION'; data: ProductInformationResponse }
  | { type: 'IS_PAGE_LOAD'; data: boolean }
  | { type: 'SET_STEP_NO'; data: number }
  | { type: 'SET_UPLOAD_TYPE'; data: string }
  | { type: 'SET_ERROR_FROM_CONFIRM_ORDER'; data: string }

export interface ContextProps {
  state: NGSOState
  dispatch: ({ type, data }) => void
}

export function reducer(state: NGSOState, action: Action): NGSOState {
  switch (action.type) {
    case 'INIT':
      return initialState
    case 'UPDATE_NGSO_INPUT':
      return {
        ...state,
        sessionData: action.data,
      }
    case 'SET_PRODUCT_INFORMATION':
      return {
        ...state,
        productInformation: action.data,
      }
    case 'IS_PAGE_LOAD':
      return {
        ...state,
        isPageLoad: action.data,
      }
    case 'SET_STEP_NO':
      return {
        ...state,
        stepNo: action.data,
      }
    case 'SET_UPLOAD_TYPE':
      return {
        ...state,
        uploadType: action.data,
      }
    case 'SET_ERROR_FROM_CONFIRM_ORDER':
      return {
        ...state,
        errorFromConfirmOrderPage: action.data,
      }
    default:
      return initialState
  }
}
